'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"overlay":"overlay-module_overlay__yUKwA","fade-in":"overlay-module_fade-in__VAGBe","hide":"overlay-module_hide__Ky5wc","fade-out":"overlay-module_fade-out__uiFNz","local":"overlay-module_local__6XUin"};

exports.default = styles;
//# sourceMappingURL=overlay.module.scss.js.map
